import React from 'react';
import { Formik, Field } from 'formik';
import { Grid } from '@inplayer-org/inplayer-ui';

// components
import Input from 'components/Fields/Input';
import { FullHeightForm, ContentContainer } from 'components/SharedStyledElements';
import FormAccordionHelper, { SectionType } from '../../components/AccordionHelper';

interface FormValues {
  url: string;
}

interface Props {
  rawContent: string;
  onSubmit: (contentString: string) => void;
  formId: string;
  closePanel: () => void;
}

const { Container, Cell } = Grid;

const RssContent = ({ rawContent, onSubmit, formId, closePanel }: Props) => {
  const initialValues: FormValues = {
    url: rawContent || '',
  };

  const handleSubmit = ({ url: contentString }: FormValues) => {
    onSubmit(contentString);
  };

  return (
    <Formik onSubmit={handleSubmit} initialValues={initialValues}>
      {() => (
        <FullHeightForm id={formId}>
          <FormAccordionHelper initialValues={initialValues} index={SectionType.Content} closePanel={closePanel} />
          <ContentContainer withPadding>
            <Container columns={1} rowGap="1rem">
              <Cell middle width={1}>
                <Field name="url" disabled component={Input} label="URL" />
              </Cell>
            </Container>
          </ContentContainer>
        </FullHeightForm>
      )}
    </Formik>
  );
};

export default RssContent;
